module.exports = __webpack_public_path__ + "img/Bank_Israel.103f06b3.svg";